import { Box, Typography } from '@mui/material';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
    ReferenceLine, ResponsiveContainer, Text,
} from 'recharts';
import { styles } from './styles';
import { BarTopLabel, ChartLegend, DeltaRow, getBarDomain, RoundedBar } from './utils';

const TripsWeeklyChart = ({ data }) => {

    const chartData = (data || [])
        .filter(d => d.currentWeekTrips > 0 || d.prevWeekTrips > 0)
        .map(d => ({
            day: d.dayLabel,
            current: d.currentWeekTrips,
            prev: d.prevWeekTrips
        }));

    const deltas = chartData.map(d => ({
        day: d.day,
        delta: d.current - d.prev
    }));

    // const calcAvgRaw = (key) => {
    //     const all = (data || []).map(d =>
    //         key === 'current' ? d.currentWeekTrips : d.prevWeekTrips
    //     );
    //     const nonZero = all.filter(v => v > 0);
    //     return nonZero.length
    //         ? Math.round(nonZero.reduce((s, v) => s + v, 0) / nonZero.length)
    //         : 0;
    // };


    // const avgs = {
    //     cw: calcAvgRaw('current'),
    //     pw: calcAvgRaw('prev'),
    // };
    return (
        <Box sx={styles.chartCard}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                <Typography sx={styles.chartTitle}>📊 Trips — Day Wise comparison</Typography>
                <ChartLegend currentColor="#1a3a7c" prevColor="#a8b8d8" />
            </Box>
            <DeltaRow deltas={deltas} />  
            <ResponsiveContainer width="100%" height={250}>
                <BarChart data={chartData} barGap={2} margin={{ top: 16, right: 20, left: 0, bottom: 0 }}>
                    <CartesianGrid vertical={false} stroke="#f0f0f0" />
                    <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{ fontSize: 14 }} />
                    <YAxis domain={getBarDomain(chartData)} tickCount={8} axisLine={false} tickLine={false} tick={{ fontSize: 15 }} />
                    <Tooltip />
                    {/* {avgs.cw > 0 && (
                        <ReferenceLine
                            y={avgs.cw}
                            stroke="#1a3a7c"
                            strokeWidth={1.5}
                            label={{ value: avgs.cw, position: 'right', fontSize: 10, fill: '#1a90ff' }}
                        />
                    )}
                    {avgs.pw > 0 && (
                        <ReferenceLine
                            y={avgs.pw}
                            stroke="#e07b39"
                            strokeDasharray="5 4"
                            strokeWidth={1.5}
                            label={{ value: avgs.pw, position: 'right', fontSize: 10, fill: '#e07b39' }}
                        />
                    )} */}
                    <Bar dataKey="current" fill="#1a3a7c" maxBarSize={28} label={<BarTopLabel />} shape={<RoundedBar />} />
                    <Bar dataKey="prev" fill="#a8b8d8" maxBarSize={28} label={<BarTopLabel />} shape={<RoundedBar />} />
                </BarChart>
            </ResponsiveContainer>
        </Box>
    );
}
export default TripsWeeklyChart